import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ShieldCheck } from 'lucide-react';
export function SalesSection() {
  return <section id="comprar" className="py-8" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <div className="max-w-md mx-auto" data-id="element-137">
          <FadeIn data-id="element-138">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-t-4" style={{
            borderColor: 'var(--color-gold)'
          }} data-id="element-139">
              <div className="px-7 py-5 text-center" style={{
              background: 'linear-gradient(135deg, var(--color-sky-light) 0%, var(--color-sky-mid) 100%)'
            }} data-id="element-140">
                <h2 className="text-xl font-bold mb-1" style={{
                color: 'var(--color-deep-blue)'
              }} data-id="element-141">
                  Accedé hoy a la colección completa
                </h2>
                <p className="text-sm font-medium" style={{
                color: 'var(--color-soft-blue)'
              }} data-id="element-142">
                  Pequeños Amigos de Dios · Material cristiano infantil digital
                </p>
              </div>

              <div className="px-7 py-6 text-center" data-id="element-143">
                <div className="mb-5" data-id="element-144">
                  <span className="text-sm font-bold block mb-1" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-145">
                    🔥 Oferta por tiempo limitado
                  </span>
                  <span className="text-base line-through opacity-50" style={{
                  color: 'var(--color-body)'
                }} data-id="element-146">
                    Antes $39.990 ARS
                  </span>
                  <div className="flex items-baseline justify-center gap-1.5 mt-0.5" data-id="element-147">
                    <span className="text-6xl font-extrabold" style={{
                    color: 'var(--color-deep-blue)'
                  }} data-id="element-148">
                      $19.990
                    </span>
                    <span className="text-xl font-bold" style={{
                    color: 'var(--color-deep-blue)'
                  }} data-id="element-149">
                      ARS
                    </span>
                  </div>
                </div>

                <ul className="space-y-2.5 mb-6 text-left max-w-[260px] mx-auto" data-id="element-150">
                  {['Producto 100% digital', 'Acceso inmediato', 'Material listo para usar'].map((text, i) => <li key={i} className="flex items-center gap-3" data-id="element-151">
                      <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{
                    backgroundColor: '#F0F7F2'
                  }} data-id="element-152">
                        <Check className="w-3 h-3" style={{
                      color: 'var(--color-green)'
                    }} data-id="element-153" />
                      </div>
                      <span className="text-base font-medium" style={{
                    color: 'var(--color-deep-blue)'
                  }} data-id="element-154">
                        {text}
                      </span>
                    </li>)}
                </ul>

                <a href="https://pago.atlasdigitalhub.com/cart/42641209360482:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 text-center text-lg font-bold text-white rounded-full transition-all duration-300 hover:-translate-y-1" style={{
                backgroundColor: 'var(--color-gold)',
                boxShadow: '0 4px 15px rgba(201,150,59,0.4)'
              }} onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = 'var(--color-gold-hover)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(201,150,59,0.5)';
              }} onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = 'var(--color-gold)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(201,150,59,0.4)';
              }} data-id="element-155">
                  QUIERO LA COLECCIÓN
                </a>

                <div className="flex items-center justify-center gap-1.5 mt-4" data-id="element-156">
                  <ShieldCheck className="w-4 h-4" style={{
                  color: 'var(--color-green)'
                }} data-id="element-157" />
                  <span className="text-sm" style={{
                  color: 'var(--color-body)'
                }} data-id="element-158">
                    Pago seguro y garantizado
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}